import { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import { IntakeContext } from '../context/IntakeContext'
// import { Link } from "react-router-dom";

// @mui material components
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import Box from '@mui/material/Box'

// Soft UI Dashboard PRO React icons
import AlarmOnIcon from '@mui/icons-material/AlarmOn'
import ScheduleIcon from '@mui/icons-material/Schedule'
import MoreTimeIcon from '@mui/icons-material/MoreTime'
import { format, addYears, addDays, max, min } from 'date-fns'

const StyledMSB = styled.div`
  text-align: center;
  position: relative;
  padding: 16px;
  height: 100%;
  cursor: pointer;
  border: 2px solid #f1f1f1;
  background: ${(props) => (props.active ? '#0671ad' : 'transparent')};
  color: ${(props) =>
    props.active ? '#fff !important' : '#344767 !important'};
  border-radius: 0.75rem;
  transition: 0.2s transform ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &:hover {
    transition: 0.2s all ease-in-out;
    border: 2px solid #a3a7aa;
    transform: scale(1.02);
    background: ${(props) => (props.active ? '#0671ad' : '#f9f9f9')};
    color: ${(props) => (props.active ? '#fff' : '#344767')};
    > h6,
    h5 {
      color: ${(props) => (props.active ? '#fff' : '#344767')};
    }
    > span {
      background-color: ${(props) => (props.active ? '#044F79' : '#f1f1f1')};
      color: ${(props) => (props.active ? '#fff' : '#5d6d8e')};
    }
  }
  > h6,
  h5 {
    color: ${(props) => (props.active ? '#fff' : '#344767')};
    letter-spacing: 0.3px;
    font-weight: 500;
    line-height: 1.4;
    margin-top: 8px;
  }
  > span {
    background-color: ${(props) => (props.active ? '#044F79' : '#f9f9f9')};
    border-radius: 50%;
    color: ${(props) => (props.active ? '#fff' : '#5d729e')};
    height: 1.5em;
    width: 1.5em;
    padding: 8px;
  }
`

const Onboarding401k = () => {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)

  const [selectedOption, setSelectedOption] = useState(null)

  useEffect(() => {
    updateIntakeStateAtKey({
      '401k': selectedOption,
    })
  }, [selectedOption])

  return (
    <Box sx={{ textAlign: 'left' }}>
      <Box mb={1}>
        <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
         Does your company offer a 401k?
        </Typography>
      </Box>
      <Typography variant="body1" fontSize={{ xs: '16px', sm: '20px' }}>
        Select one of the following options:
      </Typography>
      <Box mt={2}>
        <Grid container spacing={1} justifyContent="center" mb={3}>
          <Grid item xs={4}>
            <StyledMSB
              active={selectedOption === 'yesWithMatchingContribution'}
              onClick={() => setSelectedOption('yesWithMatchingContribution')}
            >
              <Typography variant="h6" textTransform="capitalize">
                Yes, with a matching contribution
              </Typography>
            </StyledMSB>
          </Grid>
          <Grid item xs={4}>
            <StyledMSB
              active={selectedOption === 'yesWithoutMatchingContribution'}
              onClick={() => setSelectedOption('yesWithoutMatchingContribution')}
            >
              <Typography variant="h6" textTransform="capitalize">
                Yes, without a matching contribution
              </Typography>
            </StyledMSB>
          </Grid>
          <Grid item xs={4}>
            <StyledMSB
              active={selectedOption === 'no'}
              onClick={() => setSelectedOption('no')}
            >
              <Typography variant="h6" textTransform="capitalize">
                No
              </Typography>
            </StyledMSB>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default Onboarding401k
